import * as THREE from 'three';

/** Pixel / brick missile — golden-yellow warhead, grey body. */
const BODY = 0x7a8088;
const BODY_DARK = 0x4a4f57;
const NOSE = 0xffd54f;
const NOSE_HOT = 0xfff59d;
const FIN = 0xc62828;

/**
 * Small brick-style projectile. Local +Z is nose-forward before ArcadeGame orients it.
 * Collision radius lives on `userData.radius`.
 */
export function createMissile(): THREE.Group {
  const missile = new THREE.Group();
  missile.name = 'arcade-missile';

  const bodyMat = new THREE.MeshBasicMaterial({ color: BODY });
  const darkMat = new THREE.MeshBasicMaterial({ color: BODY_DARK });
  const noseMat = new THREE.MeshBasicMaterial({ color: NOSE });
  const hotMat = new THREE.MeshBasicMaterial({ color: NOSE_HOT });
  const finMat = new THREE.MeshBasicMaterial({ color: FIN });

  // Shaft (chunkier brick silhouette — scaled further in ArcadeGame)
  const body = new THREE.Mesh(new THREE.BoxGeometry(0.32, 0.32, 1.15), bodyMat);
  body.position.set(0, 0, 0);
  missile.add(body);

  // Rear thruster brick
  const thruster = new THREE.Mesh(new THREE.BoxGeometry(0.24, 0.24, 0.22), darkMat);
  thruster.position.set(0, 0, -0.62);
  missile.add(thruster);
  const glow = new THREE.Mesh(new THREE.BoxGeometry(0.18, 0.18, 0.16), hotMat);
  glow.position.set(0, 0, -0.78);
  missile.add(glow);

  // Nose / warhead (golden)
  const nose = new THREE.Mesh(new THREE.BoxGeometry(0.28, 0.28, 0.36), noseMat);
  nose.position.set(0, 0, 0.68);
  missile.add(nose);
  const tip = new THREE.Mesh(new THREE.BoxGeometry(0.16, 0.16, 0.18), hotMat);
  tip.position.set(0, 0, 0.9);
  missile.add(tip);

  // Tiny fins
  const finGeo = new THREE.BoxGeometry(0.1, 0.38, 0.26);
  for (const rot of [0, Math.PI / 2]) {
    const fin = new THREE.Mesh(finGeo, finMat);
    fin.rotation.z = rot;
    fin.position.set(0, 0, -0.32);
    missile.add(fin);
  }

  missile.userData.radius = 0.85;
  return missile;
}
